export interface SubCategory {
  id: string;
  name: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  subCategories: SubCategory[];
}

export const categories: Category[] = [
  {
    id: 'education',
    name: '教育学习',
    icon: 'ri-graduation-cap-line',
    description: '在线课程、语言学习、技能培训与考试考证辅导',
    subCategories: [
      { id: 'k12', name: 'K12辅导' },
      { id: 'language', name: '语言培训' },
      { id: 'skill', name: '职业技能' },
      { id: 'exam', name: '考试考证' },
    ],
  },
  {
    id: 'entertainment',
    name: '娱乐休闲',
    icon: 'ri-film-line',
    description: '影视演出、音乐活动、主题乐园与休闲体验',
    subCategories: [
      { id: 'movie', name: '影视演出' },
      { id: 'music', name: '音乐活动' },
      { id: 'park', name: '主题乐园' },
      { id: 'party', name: '线下聚会' },
    ],
  },
  {
    id: 'shopping',
    name: '购物优惠',
    icon: 'ri-shopping-bag-3-line',
    description: '电商优惠、限时折扣、品牌好物与省钱攻略',
    subCategories: [
      { id: 'discount', name: '限时折扣' },
      { id: 'brand', name: '品牌好物' },
      { id: 'coupon', name: '优惠券' },
      { id: 'group', name: '团购拼单' },
    ],
  },
  {
    id: 'life',
    name: '生活服务',
    icon: 'ri-home-heart-line',
    description: '家政维修、搬家跑腿、社区服务与便民资讯',
    subCategories: [
      { id: 'cleaning', name: '家政保洁' },
      { id: 'repair', name: '维修安装' },
      { id: 'moving', name: '搬家跑腿' },
      { id: 'community', name: '社区服务' },
    ],
  },
  {
    id: 'health',
    name: '健康医疗',
    icon: 'ri-heart-pulse-line',
    description: '在线问诊、健身指导、营养咨询与健康科普',
    subCategories: [
      { id: 'consult', name: '在线问诊' },
      { id: 'fitness', name: '健身指导' },
      { id: 'nutrition', name: '营养饮食' },
      { id: 'mind', name: '心理咨询' },
    ],
  },
  {
    id: 'career',
    name: '职场提升',
    icon: 'ri-briefcase-line',
    description: '求职招聘、面试辅导、简历优化与副业机会',
    subCategories: [
      { id: 'jobs', name: '求职招聘' },
      { id: 'interview', name: '面试辅导' },
      { id: 'resume', name: '简历优化' },
      { id: 'sidejob', name: '副业机会' },
    ],
  },
  {
    id: 'technology',
    name: '科技数码',
    icon: 'ri-smartphone-line',
    description: '数码测评、软件工具、AI应用与选购指南',
    subCategories: [
      { id: 'review', name: '数码测评' },
      { id: 'software', name: '软件工具' },
      { id: 'ai', name: 'AI应用' },
      { id: 'guide', name: '选购指南' },
    ],
  },
  {
    id: 'travel',
    name: '旅游出行',
    icon: 'ri-flight-takeoff-line',
    description: '机票酒店、周边游、攻略路线与出行优惠',
    subCategories: [
      { id: 'flight', name: '机票酒店' },
      { id: 'weekend', name: '周边游' },
      { id: 'strategy', name: '旅行攻略' },
      { id: 'deal', name: '出行优惠' },
    ],
  },
];

export const regionOptions: string[] = ['全国', '北京', '上海', '广州', '深圳', '杭州', '成都', '线上'];

export const typeOptions: string[] = ['在线课程', '线下活动', '优惠活动', '到店服务', '在线咨询', '工具推荐'];

export const updateOptions: string[] = ['全部时间', '近一周', '近一月', '近三月'];